import styled from 'styled-components'
import { colors } from '../../../styles'

export const StyledRow = styled.tr`
  display: grid;
  grid-template-columns: 1.5fr 2fr 1fr 1fr 1fr 1fr 1fr;
  padding: 8px 8px;

  td,
  th {
    text-align: left;
    padding-right: 20px;
    word-break: break-word;
  }
  th > span {
    line-height: 1.2;
  }
`

export const StyledTable = styled.table`
  thead th {
    padding-bottom: 12px;
  }
  tbody tr {
    cursor: pointer;
    &:hover {
      background-color: ${colors.orange10};
    }
  }
`
